import React from 'react';
import cn from 'classnames';
import Image from "next/legacy/image";
import {Grid} from 'ht-styleguide';
import Carousel from '@components/UI/Carousel';

/* Data */
import expertService from './expertnationwideservice.data.json';

/* Styles */
import styles from './expertnationwideserviceguarantee.module.scss';

const ExpertNationWideService = () => (
  <div key={expertService.title} className={styles.container}>
    <Grid.FullWidth>
      <h3>{expertService.title}</h3>
      <Carousel
        dots
        slidesToShow={3}
        slidesToScroll={1}
        resolutions={{
          840: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 800,
          },
        }}
        className={styles.list}
      >
        {expertService.items.map(point => (
          <div className={styles.item} key={point.title}>
            <Image alt={point.title} layout="intrinsic" width={180} height={180} src={point.icon} />
            <h4 className={styles.text}>{point.title}</h4>
            <div className={cn('p1 n700 marginTop-small', styles.text)}>{point.content}</div>
          </div>
        ))}
      </Carousel>
    </Grid.FullWidth>
  </div>
);

export default ExpertNationWideService;
